module.exports = " <a class=weui_cell href=javascript:> <div class=\"weui_cell_bd weui_cell_primary\"> <p>{{title}}</p> <inline-desc v-if=inlineDesc>{{inlineDesc}}</inline-desc> </div> <div class=\"weui_cell_ft with_arrow vux-datetime-value\">{{value || placeholder}}</div> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/datetime/index.vue
// module id = 218
// module chunks = 2